
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.615","height":"9.743"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.531 5.788l-1.838 3.15a1.624 1.624 0 01-1.4.806H1.142a.609.609 0 01-.526-.916l1.838-3.15a1.624 1.624 0 011.4-.806h10.151a.609.609 0 01.526.916zM3.857 4.06h8.323V2.842a1.218 1.218 0 00-1.218-1.218H6.9L5.278 0h-4.06A1.218 1.218 0 000 1.218v7.055l1.753-3A2.444 2.444 0 013.857 4.06z","fill":"#6B7786"}})])
          )
        }
      }
    